<template>
	<div>
		<modalApproval :dialog="dialog" :val="val" :dialogType="dialogType" :detailProduct="detailProduct" @hideDialog="() => { dialog = false }"/>
        <modalconfirm ref="modalconfirmProductRecall" @action="approveData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data List Klaim Produk Recall</div>
		</div>
		
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>

		<div v-if="loading">
			<!-- <loading-card></loading-card> -->
		</div>
		<div>
			<v-slide-y-transition>
				
			</v-slide-y-transition>
			<v-card outlined class="mt-3">
				<v-data-table loading :headers="headers" :items="productRecallResults" hide-default-footer :options.sync="option" :server-items-length="productRecallPagination.total_data" disable-pagination>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom v-if="item.recall_claim_status == 'pending'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="approve(item)" class="mr-1" fab dark x-small depressed color="green" v-bind="attrs" v-on="on">
                                    <v-icon dark>mdi-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Setujui</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.recall_claim_status == 'pending'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="reject(item)" class="mr-1" fab dark x-small depressed color="red" v-bind="attrs" v-on="on">
                                    <v-icon dark>mdi-cancel</v-icon>
                                </v-btn>
                            </template>
                            <span>Tolak</span>
                        </v-tooltip>
						<v-tooltip bottom v-if="item.recall_claim_status == 'approved'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="detail(item)" class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on">
                                    <v-icon dark>mdi-text-box-search</v-icon>
                                </v-btn>
                            </template>
                            <span>Detail</span>
                        </v-tooltip>
                    </template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!productRecallPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div class="pt-5">
				<v-row v-if="productRecallPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="productRecallPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalApproval from '@/views/MLwarehouse/productRecall/modalApproval'

/*
define('PRODUCT_RECALL_TYPE', [
    1 => [
        'type' => 'RDC',
        'label' => 'Dikirim ke alamat',
    ],
    2 => [
        'type' => 'MB',
        'label' => 'Dikirim ke alamat',
    ],
    3 => [
        'type' => 'RDC',
        'label' => 'Diambil',
    ],
    4 => [
        'type' => 'MB',
        'label' => 'Diambil',
    ],
]);
*/

const listTypeLabel = [
	{
		value: '1',
		text: 'Dikirim ke alamat'
	},
	{
		value: '3',
		text: 'Diambil'
	}
]

export default {
	inject: ['theme'],
	components: {
		modalApproval,
	},
	data() {
		return {
			menu: false,
			loading: true,
			dropfilter: false,
			sortBy: 'recall_claim_id',
			sortDir: 'ASC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '50', '100' ],
			headers: [
			{ text: 'Kode Transaksi', value: 'recall_claim_tr_code', sortable: true },
			{ text: 'Mitra', value: 'recall_claim_mid', sortable: true, align: 'center'},
			{ text: 'BV Recall', value: 'recall_claim_bv', sortable: true, align: 'center'},
			{ text: 'Jenis Pengambilan', value: 'recall_claim_type_label', sortable: false, align: 'center'},
			{ text: 'Tanggal Recall', value: 'recall_claim_created_datetime', sortable: true, align: 'center'},
			{ text: 'Status', value: 'recall_claim_status', sortable: true, align: 'center'},
			{ text: 'Aksi', value: 'action', sortable: false},
			],
			filterData: [
				{
					type: 'text',
					label: 'Kode Transaksi',
					filter: {
						value: '',
						comparison: 'like',
						type: 'string',
						field: 'recall_claim_tr_code'
					}
				},
				{
					type: 'text',
					label: 'Mitra',
					filter: {
						value: '',
						comparison: 'like',
						type: 'string',
						field: 'recall_claim_mid'
					}
				},
				{
					type: 'selection',
					label: 'Jenis Pengambilan',
					item: listTypeLabel,
					itemValue: 'value',
					itemText: 'text',
					filter: {
						value: '',
						comparison: '=',
						type: 'string',
						field: 'recall_claim_type'
					}
				},
				{
					type: 'selection',
					label: 'Status',
					item: [
						{
							value: 'pending',
							text: 'pending',
						},
						{
							value: 'approved',
							text: 'approved',
						},
						{
							value: 'rejected',
							text: 'rejected',
						}
					],
					itemValue: 'value',
					itemText: 'text',
					filter: {
						value: '',
						comparison: '=',
						type: 'string',
						field: 'recall_claim_status'
					}
				},
			],
			params:[],
			paramProp: '',
			val: {},
			dialog: false,
			dialogConfirm: false,
			search: '',
			propId: 0,
			propStatus: '',
			dialogType: '',
			detailProduct: {},
		}
	},
	computed: {
		...mapState('productRecall', ['productRecallResults', 'productRecallPagination', 'response', 'detailApprovalproductRecall']),
	},
	methods: {
		...mapActions('productRecall', ['getDataProductRecall', 'approveProductRecall', 'detailProductRecall']),
		...mapMutations('productRecall', ['listProductRecall']),
        ...mapMutations(['setOverlay', 'setFilter']),

		async getData() {
			await this.getDataProductRecall(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
        approve(item){
			this.propId = item.recall_claim_id
			this.propStatus = 1
			this.val = item
			this.dialog = true
			this.dialogType = 'approve'
		},
        reject(item){
			this.propId = item.recall_claim_id
			this.propStatus = 2
			let msg = `Yakin ingin menolak transaksi ${item.recall_claim_tr_code}`
			this.$refs.modalconfirmProductRecall.setMessage(msg)
			this.$refs.modalconfirmProductRecall.showConfirm()
		},
		async detail(item){
			this.propId = item.recall_claim_id

			await this.detailProductRecall({
                id: this.propId,
            }).then( () => {
				if (this.detailApprovalproductRecall.code == 200) {
					this.val = item
					this.dialog = true
					this.dialogType = 'detail'
					this.detailProduct = this.detailApprovalproductRecall.data
				}
			})
		},
        async approveData () {
			await this.setOverlay(true)
			await this.$refs.modalconfirmProductRecall.hideConfirm()
			await this.approveProductRecall({
                id: this.propId,
                status: this.propStatus
            }).then( () => {
				if(this.response.code == 200) {
					this.getData()
				}
			})
			await this.setOverlay(false)
		},
		reset() {
			this.val = {}
			this.konfirmasiSukses('')
			this.paramProp = ''
			this.propId = 0
			this.propStatus = ''
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Data List Klaim Produk Recall`)
		this.getData()
		this.setFilter(this.filterData)
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>